import { darken, lighten } from 'polished';
import { LIGHTEN, DARKEN } from '../constants';

export default {
  'primary': {
    '50': '#E8F1FD',
    '100': '#D1E3FA',
    '200': '#BAD5F8',
    '300': '#A3C7F5',
    '400': '#8CB9F3',
    '500': '#76ABF1',
    '600': '#5F9DEE',
    '700': '#488FEC',
    '800': '#3181E9',
    '900': '#1A73E7',
    'main': '#1A73E7',
    'light': lighten(LIGHTEN, '#1A73E7'),
    'dark': darken(DARKEN, '#1A73E7'),
    'contrastText': '#fff',
  },
  'backdrop': {
    'mobile': '#32609C',
    'divider': '#204676'
  },
  'common': { 'black': '#000', 'white': '#fff' },
  'text': {
    'primary': '#344767',
    'secondary': '#7B809A',
    'disabled': '#888DA4',
  },
  'grey': {
    '10': '#F7F8FA',
    '50': '#F2F2F5',
    '100': '#E5E6EB',
    '200': '#D9D9D9',
    '300': '#CACCD7',
    '400': '#BDBFCC',
    '500': '#B0B3C2',
    '600': '#A3A6B8',
    '700': '#9599AE',
    '800': '#888DA4',
    '900': '#7B809A',
    'main': '#7B809A',
    'light': darken(LIGHTEN, '#7B809A'),
    'dark': darken(DARKEN, '#7B809A'),
    'contrastText': '#fff',
  },
  'teams': {
    'main': '#A2A7EE',
    'dark': darken(DARKEN, '#A2A7EE'),
    'contrastText': '#fff',
  },
  'google': {
    'main': '#5FB664',
    'dark': darken(DARKEN, '#5FB664'),
    'contrastText': '#fff',
  },
  'error': {
    '50': '#FFE5E5',
    '100': '#FFCCCC',
    '200': '#FFB3B3',
    '300': '#FF9999',
    '400': '#FF8080',
    '500': '#FF6666',
    '600': '#FF4D4D',
    '700': '#FF3333',
    '800': '#FF1A1A',
    '900': '#FF0000',
    'main': '#FF0000',
    'light': darken(LIGHTEN, '#FF0000'),
    'dark': darken(DARKEN, '#FF0000'),
    'contrastText': '#fff',
  },
  'success': {
    '50': '#EFF8EF',
    '100': '#DFF0E0',
    '200': '#CFE9D1',
    '300': '#BFE2C1',
    '400': '#AFDBB1',
    '500': '#9FD3A2',
    '600': '#8FCC93',
    '700': '#7FC583',
    '800': '#6FBD74',
    '900': '#5FB664',
    'main': '#5FB664',
    'light': darken(LIGHTEN, '#5FB664'),
    'dark': darken(DARKEN, '#5FB664'),
    'contrastText': '#fff',
  },
  'warning': {
    '50': '#FFF4E7',
    '100': '#FEEACF',
    '200': '#FEDFB7',
    '300': '#FED59F',
    '400': '#FDCB87',
    '500': '#FDC06F',
    '600': '#FDB657',
    '700': '#FDAB3F',
    '800': '#FCA027',
    '900': '#FC960F',
    'main': '#FC960F',
    'light': darken(LIGHTEN, '#FC960F'),
    'dark': darken(DARKEN, '#FC960F'),
    'contrastText': '#fff',
  },
  'secondary': {
    '50': '#EBEDF0',
    '100': '#D6DAE1',
    '200': '#C2C8D1',
    '300': '#AEB5C2',
    '400': '#99A3B3',
    '500': '#8591A4',
    '600': '#717E95',
    '700': '#5D6C85',
    '800': '#485976',
    '900': '#344767',
    'main': '#344767',
    'light': lighten(LIGHTEN, '#344767'),
    'dark': darken(DARKEN, '#344767'),
    'contrastText': '#fff',
  },
  'info': {
    '50': '#FDE9EF',
    '100': '#FBD2E0',
    '200': '#F8BCD0',
    '300': '#F6A5C1',
    '400': '#F6A5C1',
    '500': '#F279A1',
    '600': '#F06292',
    '700': '#ED4C82',
    '800': '#EB3573',
    '900': '#E91F63',
    'main': '#E91F63',
    'light': darken(LIGHTEN, '#E91F63'),
    'dark': darken(DARKEN, '#E91F63'),
    'contrastText': '#FFFFFF',
  },
  'contrastThreshold': 3,
  'tonalOffset': 0.2,
  'background': { paper: '#F8F9FA', 'default': '#fff' },
  'action': {
    'active': 'rgba(0, 0, 0, 0.54)',
    'hover': 'rgba(0, 0, 0, 0.04)',
    'hoverOpacity': 0.04,
    'selected': 'rgba(0, 0, 0, 0.08)',
    'selectedOpacity': 0.08,
    'disabled': 'rgba(0, 0, 0, 0.26)',
    'disabledBackground': 'rgba(0, 0, 0, 0.12)',
    'disabledOpacity': 0.38,
    'focus': 'rgba(0, 0, 0, 0.12)',
    'focusOpacity': 0.12,
    'activatedOpacity': 0.12,
  },
};
